import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requirePermission, requireAnyPermission, requireSuperAdmin }) {
  const { admin, loading, can, isSuperAdmin } = useAuth();

  if (loading) return null;
  if (!admin) return <Navigate to="/login" replace />;
  if (requireSuperAdmin && !isSuperAdmin) return <Navigate to="/dashboard" replace />;
  if (requirePermission && !can(requirePermission)) return <Navigate to="/dashboard" replace />;
  if (requireAnyPermission && !requireAnyPermission.some((permission) => can(permission))) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
